import { useEffect } from "react";
import ImmersiveWizard from "./ImmersiveWizard";
import { useExperiment } from "../../hooks/useExperiment";
import { useNavigate } from "../../hooks/useNavigate";
import PageLoader from "../../components/PageLoader";

const ImmersiveWizardRouter = () => {
  const { useExperimentValue, isLoading } = useExperiment();
  const isWizardEnabled = useExperimentValue("immersive-wizard", false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isWizardEnabled) {
      navigate("/start");
    }
  }, [isLoading, isWizardEnabled, navigate]);

  if (isLoading) {
    return <PageLoader />;
  }

  return <ImmersiveWizard />;
};

export default ImmersiveWizardRouter;
